import React, { useState, useEffect, useRef } from 'react'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import styled from '@mui/system/styled';

const ProviderInvoice = ({invoice}) => {

	//const [height, setHeight] = useState(0)
	//const [pages, setPages] = useState(0)
	const ref = useRef(null)
	
	// useEffect(() => {
    // 	const height = ref.current.clientHeight
    // 	console.log('#### height')
    // 	console.log(height)
    // 	const totalPages = Math.ceil(height / 944)
    // 	console.log('#### totalPages')
    // 	console.log(totalPages)

	// 	for (var i = 1; i <= totalPages; i++) {
	// 		console.log("Page " + i + " of " + totalPages + ' set marginTop ' + (i * 944))
	// 		var pageNumberDiv = document.createElement("div");
	// 		var pageNumber = document.createTextNode("Page " + i + " of " + totalPages);
	// 		pageNumberDiv.style.position = "absolute";
	// 		pageNumberDiv.style.marginTop = "calc((" + i + " * (280mm - 0.5px)) - 40px)"; //297mm A4 pageheight; 0,5px unknown needed necessary correction value; additional wanted 40px margin from bottom(own element height included)
	// 		//pageNumberDiv.style.height = "16px";
	// 		pageNumberDiv.appendChild(pageNumber);
	// 		ref.current.appendChild(pageNumberDiv);
	// 		pageNumberDiv.style.left = "calc(100% - (" + pageNumberDiv.offsetWidth + "px + 40px))";
	// 	}
  	// })

  	// function addPageNumbers() {
	// 	var totalPages = Math.ceil(document.body.scrollHeight / 1123);  //842px A4 pageheight for 72dpi, 1123px A4 pageheight for 96dpi, 
	// 	for (var i = 1; i <= totalPages; i++) {
	// 		var pageNumberDiv = document.createElement("div");
	// 		var pageNumber = document.createTextNode("Page " + i + " of " + totalPages);
	// 		pageNumberDiv.style.position = "absolute";
	// 		pageNumberDiv.style.marginTop = "calc((" + i + " * (297mm - 0.5px)) - 40px)"; //297mm A4 pageheight; 0,5px unknown needed necessary correction value; additional wanted 40px margin from bottom(own element height included)
	// 		pageNumberDiv.style.height = "16px";
	// 		pageNumberDiv.appendChild(pageNumber);
	// 		document.body.insertBefore(pageNumberDiv, document.getElementById("content"));
	// 		pageNumberDiv.style.left = "calc(100% - (" + pageNumberDiv.offsetWidth + "px + 20px))";
	// 	}
	// }

	const STOP_REGION = process.env.REACT_APP_STOP_REGION

	const TableItem = styled('div')(({ theme }) => ({
		backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
		border: '1px solid',
		borderColor: theme.palette.mode === 'dark' ? '#444d58' : '#ced7e0',
		padding: theme.spacing(.5),
		borderRadius: '4px',
		textAlign: 'center',
	}));

	const days = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31];

	return (
		<div id='content' ref={ref}>
		<Box >
			{/*START HEADER*/}
              <Typography sx={{ textAlign: 'center' }} variant="h4" >
                Westcare of California STOP Area {STOP_REGION === '3' ? 'III' : 'I'}
              </Typography>
              <Typography sx={{ textAlign: 'center' }} variant="h6" >
                Treatment Verification Report for {invoice.mthID}
              </Typography>
              <Typography sx={{ textAlign: 'center' }} variant="h5" >
                Approve and Email back to CA.DATA.STOP@WESTCARE.COM
              </Typography>
              <hr/>
			{/*END HEADER*/}

			{/*BEGIN ORG*/}
              <Grid container spacing={0}>
                <Grid xs={8}>
                  <Typography variant="h5" sx={{ fontWeight: '800' }}>
                    {invoice.orgKey}
                  </Typography>
                </Grid>
                <Grid xs={2}>
                  <Typography variant="h6" sx={{ textAlign: 'right' }}>
                    Phone:
                  </Typography>
                </Grid>
                <Grid xs={2}>
                  <Typography variant="h6" sx={{ textAlign: 'right' }}>
                    {invoice.orgPhone}
                  </Typography>
                </Grid>
                <Grid xs={8}>
                  <Typography variant="h6" mt={-1}>
                    {invoice.orgAdr}
                  </Typography>
                </Grid>
                <Grid xs={2}>
                  <Typography variant="h6" sx={{ textAlign: 'right' }} mt={-.5}>
                    Fax:
                  </Typography>
                </Grid>
                <Grid xs={2}>
                  <Typography variant="h6" sx={{ textAlign: 'right' }} mt={-.5}>
                    {invoice.orgFax}
                  </Typography>
                </Grid>
                <Grid xs={12}>
                  <Typography variant="h6" mt={-1}>
                    {invoice.orgCity + ', ' + invoice.orgState + ' ' + invoice.orgZip}
                  </Typography>
                </Grid>
              </Grid>
            {/*END ORG*/}
              

              <Box sx={{ flexGrow: 1}}>  
                <Grid container spacing={0} pl={1}>
                {/*BEGIN CBP */}
                  <Grid xs={8} >
                    <TableItem>
                      <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
                        {invoice.cboName}
                      </Typography>
                    </TableItem>
                  </Grid>
                  <Grid xs={2}>
                    <TableItem>
                      <Typography sx={{ textAlign: 'right', fontWeight: '800' }} variant="h6" >
                        Invoice ID: {invoice.cboInvID}
                      </Typography>
                    </TableItem>
                  </Grid>
                  <Grid xs={2}>
                    <TableItem>
                      <Typography sx={{ textAlign: 'right', fontWeight: '800' }} variant="h6" >
                        Cbp ID: {invoice.cboID}
                      </Typography>
                    </TableItem>
                  </Grid>
                  <Grid xs={12}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'nowrap',
                      }}  
                    >
                      <TableItem 
                        sx={{
                          display: 'flex', 
                          justifyContent: 'left',
                          width: 60,
                          maxWidth: { xs: 60, md: 60 },
                        }}
                      >
                        <Typography sx={{ textAlign: 'left'}} variant="body2" >
                          CDC#
                        </Typography>
                      </TableItem>
                      <TableItem 
                        sx={{
                          display: 'flex', 
                          justifyContent: 'left',
                          width: 125,
                          maxWidth: { xs: 125, md: 125 },
                        }}
                      >
                        <Typography sx={{ textAlign: 'left'}} variant="body2" >
                          Participant
                        </Typography>
                      </TableItem>
                      <TableItem 
                        sx={{
                          display: 'flex', 
                          justifyContent: 'left',
                          width: 40,
                          maxWidth: { xs: 40, md: 40 },
                        }}
                      >
                        <Typography sx={{ textAlign: 'left'}} variant="body2" >
                          Type
                        </Typography>
                      </TableItem>
                      {days.map(day => (
                        <TableItem 
                          sx={{
                            display: 'flex', 
                            justifyContent: 'center',
                            width: 21,
                            maxWidth: { xs: 21, md: 21 },
                          }}
                        >
                          <Typography sx={{ textAlign: 'left'}} variant="body2" >
                            {day}
                          </Typography>
                        </TableItem>
                      ))}
                      <TableItem 
                        sx={{
                          display: 'flex',
                          justifyContent: 'right',
                          width: 40,
                          maxWidth: { xs: 40, md: 40 }, 
                          marginLeft: 2
                        }}
                      >
                        <Typography sx={{ textAlign: 'right'}} variant="body2" >
                          Units
                        </Typography>
                      </TableItem>
                      <TableItem 
                        sx={{
                          display: 'flex', 
                          justifyContent: 'right',
                          width: 80,
                          maxWidth: { xs: 80, md: 80 },
                        }}
                      >
                        <Typography sx={{ textAlign: 'right'}} variant="body2" >
                        Amount
                        </Typography>
                      </TableItem>
                    </Box>
                    {/*END CBP*/}


                    {/*BEGIN AUTH*/}
                    {invoice.auths.map((auth, index) => (
                      <div key={index}>
                      {
                        (index+1) % 2 == 0 &&
                        <>
                        <div className="page-break" />
                        <Box pt={0}></Box>
                        </>                      
                      }
                        <Typography sx={{ textAlign: 'left', fontWeight: '800' }} variant="h6" >
                          {auth.type}
                        </Typography>
                        <hr/>
                    {/*END AUTH*/}
                    

                        

                        {auth.participants.map(p => (
                          <div key={p.prtID}>
                            <Box
                              sx={{
                                display: 'flex',
                                flexWrap: 'nowrap',
                              }}  
                            >
                              <Box 
                                sx={{
                                  display: 'flex', 
                                  justifyContent: 'left',
                                  width: 185,
                                  maxWidth: { xs: 185, md: 185 },
                                }}
                              >
                                <Typography sx={{ textAlign: 'left', fontWeight: '800'}} variant="body2" >
                                  {p.prtLName + ', ' + p.prtFName}
                                </Typography>
                              </Box>
                              <Box 
                                sx={{
                                  display: 'flex', 
                                  justifyContent: 'left',
                                  width: 0,
                                  maxWidth: { xs: 125, md: 125 },
                                }}
                              >
                                <Typography sx={{ textAlign: 'left', fontWeight: '800'     }} variant="body2" >
                                  {/**
                                    p.prtLName + ', ' + p.prtFName
                                  **/}
                                </Typography>
                              </Box>
                              <Box 
                                sx={{
                                  display: 'flex', 
                                  justifyContent: 'left',
                                  width: 40,
                                  maxWidth: { xs: 40, md: 40 },
                                }}
                              >
                                <Typography sx={{ textAlign: 'left'}} variant="body2" >
                                  Ind
                                </Typography>
                              </Box>
                              {days.map(day => (
                                <TableItem 
                                  sx={{
                                    display: 'flex', 
                                    justifyContent: 'center',
                                    width: 21,
                                    maxWidth: { xs: 21, md: 21 },
                                  }}
                                >
                                  <Typography sx={{ textAlign: 'left'}} variant="body2" >
                                    {(p['i' + day]) === 'P' ? '\u2713' : ''}
                                  </Typography>
                                </TableItem>
                              ))}
                              <Box 
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'right',
                                  width: 40,
                                  maxWidth: { xs: 40, md: 40 }, 
                                  marginLeft: 2
                                }}
                              >
                                <Typography sx={{ textAlign: 'right'}} variant="body2" >
                                  {p.authIServices}
                                </Typography>
                              </Box>
                              <Box 
                                sx={{
                                  display: 'flex', 
                                  justifyContent: 'right',
                                  width: 80,
                                  maxWidth: { xs: 80, md: 80 },
                                }}
                              >
                                <Typography sx={{ textAlign: 'right'}} variant="body2" >
                                  {(p.authIServices * p.authIRate).toLocaleString('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                  })}
                                </Typography>
                              </Box>
                            </Box>

                            { !invoice.modResYN &&
                            <Box
                              sx={{
                                display: 'flex',
                                flexWrap: 'nowrap',
                              }}  
                            >
                              <Box 
                                  sx={{
                                    display: 'flex', 
                                    justifyContent: 'left',
                                    width: 180,
                                  }}
                                >
                              </Box>  
                              <Box 
                                sx={{
                                  display: 'flex', 
                                  justifyContent: 'left',
                                  width: 45,
                                  maxWidth: { xs: 60, md: 60 },
                                }}
                              >
                                <Typography sx={{ textAlign: 'left'}} variant="body2" >
                                  Grp
                                </Typography>
                              </Box>
                              {days.map(day => (
                                <TableItem 
                                  sx={{
                                    display: 'flex', 
                                    justifyContent: 'center',
                                    width: 21,
                                    maxWidth: { xs: 21, md: 21 },
                                  }}
                                >
                                  <Typography sx={{ textAlign: 'left'}} variant="body2" >
                                    {(p['g' + day]) === 'P' ? '\u2713' : ''}
                                  </Typography>
                                </TableItem>
                              ))}
                              <Box 
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'right',
                                  width: 40,
                                  maxWidth: { xs: 40, md: 40 }, 
                                  marginLeft: 2
                                }}
                              >
                                <Typography sx={{ textAlign: 'right'}} variant="body2" >
                                  {p.authGServices}
                                </Typography>
                              </Box>
                              <Box 
                                sx={{
                                  display: 'flex', 
                                  justifyContent: 'right',
                                  width: 80,
                                  maxWidth: { xs: 80, md: 80 },
                                }}
                              >
                                <Typography sx={{ textAlign: 'right'}} variant="body2" >
                                  {(p.authGServices * p.authGRate).toLocaleString('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                  })}
                                </Typography>
                              </Box>
                            </Box>
                          }



                            <Box pl={2} >
                              <Typography sx={{ textAlign: 'left'}} variant="body2" mt={-2}>
                                CDC#: {p.epdIcnCDC}
                              </Typography>
                              <Typography sx={{ textAlign: 'left'}} variant="body2" mt={-.5}>
                                (Adm: {new Date(p.sapAthAdmDate).toLocaleDateString()}{p.sapAthDchDate ? ' Dch: ' + new Date(p.sapAthDchDate).toLocaleDateString() : ''})
                              </Typography>
                            </Box>  
                          </div>
                        ))}
                        <Box
                          sx={{
                            display: 'flex',
                            flexWrap: 'nowrap',
                          }}  
                        >
                          <Box 
                            sx={{
                              display: 'flex', 
                              justifyContent: 'left',
                              width: 225,
                              maxWidth: { xs: 225, md: 225 },
                            }}
                          >
                            <Typography sx={{ textAlign: 'left', fontWeight: '800'}} variant="h6" >
                              Total CBP Services
                            </Typography>
                          </Box>
                          {days.map(day => (
                            <TableItem 
                              sx={{
                                display: 'flex', 
                                justifyContent: 'center',
                                width: 21,
                                maxWidth: { xs: 21, md: 21 },
                              }}
                            >
                              <Typography sx={{ textAlign: 'left'}} variant="body2" >
                                {auth[day.toString()]}
                              </Typography>
                            </TableItem>
                          ))}
                          <Box 
                            sx={{
                              display: 'flex',
                              justifyContent: 'right',
                              width: 40,
                              maxWidth: { xs: 40, md: 40 }, 
                              marginLeft: 2
                            }}
                          >
                            <Typography sx={{ textAlign: 'right'}} variant="body2" fontWeight="800">
                              {auth.authIServices + auth.authGServices}
                            </Typography>
                          </Box>
                          <Box 
                            sx={{
                              display: 'flex', 
                              justifyContent: 'right',
                              width: 80,
                              maxWidth: { xs: 80, md: 80 },
                            }}
                          >
                            <Typography sx={{ textAlign: 'right'}} variant="body2" fontWeight="800">
                              {((auth.authIServices * auth.authIRate) + (auth.authGServices * auth.authGRate)).toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                              })}
                            </Typography>
                          </Box>
                        </Box>
                        <Box
                          pt={1}
                          sx={{
                            display: 'flex',
                            flexWrap: 'nowrap',
                          }}  
                        >
                          <Box 
                            sx={{                              
                              display: 'flex', 
                              justifyContent: 'left',
                              width: 225,
                              maxWidth: { xs: 225, md: 225 },
                            }}
                          >
                            <Typography sx={{ textAlign: 'left', fontWeight: '800'}} variant="h6" >
                              Total Participants: {auth.participants.length}
                            </Typography>
                          </Box>
                          <Box 
                            sx={{
                              display: 'flex', 
                              justifyContent: 'left',
                              width: 230,
                              maxWidth: { xs: 230, md: 230 },
                            }}
                          >
                            <TableItem sx={{ textAlign: 'left'}} variant="h4" >
                              <Typography sx={{ textAlign: 'left'}} variant="body2" >
                                CBP Rate(s)&nbsp;&nbsp;&nbsp;
                              </Typography>
                            </TableItem>
                          </Box>
                          <Box 
                            sx={{
                              display: 'flex',
                              justifyContent: 'right',
                              width: 482,
                              maxWidth: { xs: 482, md: 482 }, 
                            }}
                          >
                            <Typography sx={{ textAlign: 'right'}} variant="body2" >
                              
                            </Typography>
                          </Box>
                          <Box 
                            sx={{
                              display: 'flex', 
                              justifyContent: 'right',
                              width: 80,
                              maxWidth: { xs: 80, md: 80 },
                            }}
                          >
                            <Typography sx={{ textAlign: 'right'}} variant="body2" >
                              
                            </Typography>
                          </Box>
                        </Box>  

                        <Box
                          sx={{
                            display: 'flex',
                            flexWrap: 'nowrap',
                          }}  
                        >
                          <Box 
                            sx={{                              
                              display: 'flex', 
                              justifyContent: 'left',
                              width: 225,
                              maxWidth: { xs: 225, md: 225 },
                            }}
                          >
                            <Typography sx={{ textAlign: 'left', fontWeight: '800'}} variant="h6" >
                            </Typography>
                          </Box>
                          <Box 
                            sx={{
                              display: 'flex', 
                              justifyContent: 'left',
                              width: 30,
                              maxWidth: { xs: 30, md: 30 },
                            }}
                          >
                            <TableItem sx={{ textAlign: 'left'}} variant="h4" >
                              <Typography sx={{ textAlign: 'left'}} variant="body2" >
                                Ind&nbsp;
                              </Typography>
                            </TableItem>
                          </Box>
                          <Box 
                            sx={{
                              display: 'flex', 
                              justifyContent: 'left',
                              width: 200,
                              maxWidth: { xs: 200, md: 200 },
                            }}
                          >
                            <TableItem sx={{ textAlign: 'left'}} variant="h4" >
                              <Typography sx={{ textAlign: 'left'}} variant="body2" >
                                {(auth.authIRate).toLocaleString('en-US', {
                                  style: 'currency',
                                  currency: 'USD',
                                })}
                              </Typography>
                            </TableItem>
                          </Box>
                          <Box 
                            sx={{
                              display: 'flex',
                              justifyContent: 'right',
                              width: 482,
                              maxWidth: { xs: 482, md: 482 }, 
                            }}
                          >
                          </Box>
                          <Box 
                            sx={{
                              display: 'flex', 
                              justifyContent: 'right',
                              width: 80,
                              maxWidth: { xs: 80, md: 80 },
                            }}
                          >
                          </Box>
                        </Box>

                        { !invoice.modResYN &&
                        <Box
                          sx={{
                            display: 'flex',
                            flexWrap: 'nowrap',
                          }}  
                        >
                        <Box 
                            sx={{
                              display: 'flex', 
                              justifyContent: 'left',
                              width: 225,
                              maxWidth: { xs: 225, md: 225 },
                            }}
                          >
                        </Box>    
                        
                          <Box 
                            sx={{
                              display: 'flex', 
                              justifyContent: 'left',
                              width: 30,
                              maxWidth: { xs: 30, md: 30 },
                            }}
                          >
                            <TableItem sx={{ textAlign: 'left'}} variant="h4" >
                              <Typography sx={{ textAlign: 'left'}} variant="body2" >
                                Grp
                              </Typography>
                            </TableItem>
                          </Box>
                          <Box 
                            sx={{
                              display: 'flex', 
                              justifyContent: 'left',
                              width: 200,
                              maxWidth: { xs: 200, md: 200 },
                            }}
                          >
                            <TableItem sx={{ textAlign: 'left'}} variant="h4" >
                              <Typography sx={{ textAlign: 'left'}} variant="body2" >
                                &nbsp;{(auth.authGRate).toLocaleString('en-US', {
                                  style: 'currency',
                                  currency: 'USD',
                                })}
                              </Typography>
                            </TableItem>
                          </Box>
                        
                           <Box 
                            sx={{
                              display: 'flex',
                              justifyContent: 'right',
                              width: 482,
                              maxWidth: { xs: 482, md: 482 }, 
                            }}
                          >
                          </Box>
                          <Box 
                            sx={{
                              display: 'flex', 
                              justifyContent: 'right',
                              width: 80,
                              maxWidth: { xs: 80, md: 80 },
                            }}
                          >
                          </Box>
                          </Box>
                        }


                        <Box
                          sx={{
                            display: 'flex',
                            flexWrap: 'nowrap',
                          }}  
                        >
                          <Box
                            pb={1} 
                            sx={{                              
                              display: 'flex', 
                              justifyContent: 'left',
                              width: 225,
                              maxWidth: { xs: 225, md: 225 },
                            }}
                          >
                            <Typography sx={{ textAlign: 'left', fontWeight: '800'}} variant="h6" >
                              
                            </Typography>
                          </Box>
                          <Box 
                            sx={{
                              display: 'flex',
                              justifyContent: 'right',
                              width: 708,
                              maxWidth: { xs: 708, md: 708 }, 
                            }}
                          >
                            <Typography sx={{ textAlign: 'right'}} variant="body2" >
                              
                            </Typography>
                          </Box>
                          <Box 
                            sx={{
                              display: 'flex', 
                              justifyContent: 'right',
                              width: 80,
                              maxWidth: { xs: 80, md: 80 },
                            }}
                          >
                            <Typography sx={{ textAlign: 'right'}} variant="body2" >
                              
                            </Typography>
                          </Box>
                        </Box>  
                      </div>  
                    ))}

                                

                    

                    {/*{
                    <div className="page-break" />                    
                    }*/}

                    <Box
                      pt={0}
                      sx={{
                        display: 'flex',
                        flexWrap: 'nowrap',
                      }}  
                    >
                      <Box 
                        sx={{
                          display: 'flex', 
                          justifyContent: 'left',
                          width: 225,
                          maxWidth: { xs: 225, md: 225 },
                        }}
                      >
                        <Typography sx={{ textAlign: 'left', fontWeight: '800'}} variant="h6" >
                          Grand Total Services
                        </Typography>
                      </Box>
                      {days.map(day => (
                        <TableItem 
                          sx={{
                            display: 'flex', 
                            justifyContent: 'center',
                            width: 21,
                            maxWidth: { xs: 21, md: 21 },
                          }}
                        >
                          <Typography sx={{ textAlign: 'left'}} variant="body2" >
                            {invoice[day.toString()]}
                          </Typography>
                        </TableItem>
                      ))}
                      <Box 
                        sx={{
                          display: 'flex',
                          justifyContent: 'right',
                          width: 40,
                          maxWidth: { xs: 40, md: 40 }, 
                          marginLeft: 2
                        }}
                      >
                        <Typography sx={{ textAlign: 'right'}} variant="body2" fontWeight="800">
                          {invoice.invoiceIServices + invoice.invoiceGServices}
                        </Typography>
                      </Box>
                      <Box 
                        sx={{
                          display: 'flex', 
                          justifyContent: 'right',
                          width: 80,
                          maxWidth: { xs: 80, md: 80 },
                        }}
                      >
                        <Typography sx={{ textAlign: 'right'}} variant="body2" fontWeight="800">
                          {((invoice.invoiceIServices * invoice.invoiceIRate) + (invoice.invoiceGServices * invoice.invoiceGRate)).toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                          })}
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      pt={1}
                      sx={{
                        display: 'flex',
                        flexWrap: 'nowrap',
                      }}  
                    >
                      <Box
                        sx={{                              
                          display: 'flex', 
                          justifyContent: 'left',
                          width: 225,
                          maxWidth: { xs: 225, md: 225 },
                        }}
                      >
                        <Typography sx={{ textAlign: 'left', fontWeight: '800'}} variant="h6" >
                          Grand Total Participants: 
                        </Typography>
                      </Box>
                      <Box 
                        sx={{
                          display: 'flex', 
                          justifyContent: 'left',
                          width: 225,
                          maxWidth: { xs: 225, md: 225 },
                        }}
                      >
                        <TableItem sx={{ textAlign: 'left'}} variant="h4" >
                          <Typography sx={{ textAlign: 'left'}} variant="body2" >
                            CBP Rate(s)&nbsp;&nbsp;&nbsp;
                          </Typography>
                        </TableItem>
                      </Box>
                      <Box 
                        sx={{
                          display: 'flex',
                          justifyContent: 'right',
                          width: 482,
                          maxWidth: { xs: 482, md: 482 }, 
                        }}
                      >
                        <Typography sx={{ textAlign: 'right'}} variant="body2" fontWeight="800">
                          Current Month Treatments Total:
                        </Typography>
                      </Box>
                      <Box 
                        sx={{
                          display: 'flex', 
                          justifyContent: 'right',
                          width: 80,
                          maxWidth: { xs: 80, md: 80 },
                        }}
                      >
                        <Typography sx={{ textAlign: 'right'}} variant="body2" fontWeight="800">
                          {(invoice.cboInvDcpInMthTtlActlAmt).toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                          })}
                        </Typography>
                      </Box>
                    </Box>  

                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'nowrap',
                      }}  
                    >
                      <Box 
                        sx={{                              
                          display: 'flex', 
                          justifyContent: 'left',
                          width: 225,
                          maxWidth: { xs: 225, md: 225 },
                        }}
                      >
                        <Typography sx={{ textAlign: 'left', fontWeight: '800'}} variant="h6" >
                          
                        </Typography>
                      </Box>
                      <Box 
                        sx={{
                          display: 'flex', 
                          justifyContent: 'left',
                          width: 30,
                          maxWidth: { xs: 30, md: 30 },
                        }}
                      >
                        <TableItem sx={{ textAlign: 'left'}} variant="h4" >
                          <Typography sx={{ textAlign: 'left'}} variant="body2" >
                            Ind&nbsp;
                          </Typography>
                        </TableItem>
                      </Box>
                      <Box 
                        sx={{
                          display: 'flex', 
                          justifyContent: 'left',
                          width: 196,
                          maxWidth: { xs: 196, md: 196 },
                        }}
                      >
                        <TableItem sx={{ textAlign: 'left'}} variant="h4" >
                          <Typography sx={{ textAlign: 'left'}} variant="body2" >
                            {(invoice.invoiceIRate).toLocaleString('en-US', {
                              style: 'currency',
                              currency: 'USD',
                            })}
                          </Typography>
                        </TableItem>
                      </Box>
                      <Box 
                        sx={{
                          display: 'flex',
                          justifyContent: 'right',
                          width: 482,
                          maxWidth: { xs: 482, md: 482 }, 
                        }}
                      >
                        <Typography sx={{ textAlign: 'right'}} variant="body2" fontWeight="800">
                          Out of Month Treatments Total:
                        </Typography>
                      </Box>
                      <Box 
                        sx={{
                          display: 'flex', 
                          justifyContent: 'right',
                          width: 80,
                          maxWidth: { xs: 80, md: 80 },
                        }}
                      >
                        <Typography sx={{ textAlign: 'right'}} variant="body2" fontWeight="800">
                          {(invoice.cboInvAmt-invoice.cboInvDcpInMthTtlActlAmt).toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                          })}
                        </Typography>
                      </Box>
                    </Box>  
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'nowrap',
                      }}  
                    >
                      <Box 
                        sx={{                              
                          display: 'flex', 
                          justifyContent: 'left',
                          width: 225,
                          maxWidth: { xs: 225, md: 225 },
                        }}
                      >
                        <Typography sx={{ textAlign: 'left', fontWeight: '800'}} variant="h6" >
                          
                        </Typography>
                      </Box>
                      <Box 
                        sx={{
                          display: 'flex', 
                          justifyContent: 'left',
                          width: 30,
                          maxWidth: { xs: 30, md: 30 },
                        }}
                      >
                        { !invoice.modResYN &&
                        <TableItem sx={{ textAlign: 'left'}} variant="h4" >
                          <Typography sx={{ textAlign: 'left'}} variant="body2" >
                            Grp
                          </Typography>
                        </TableItem>
                      }
                      </Box>
                      <Box 
                        sx={{
                          display: 'flex', 
                          justifyContent: 'left',
                          width: 196,
                          maxWidth: { xs: 196, md: 196 },
                        }}
                      >
                        { !invoice.modResYN &&
                        <TableItem sx={{ textAlign: 'left'}} variant="h4" >
                          <Typography sx={{ textAlign: 'left'}} variant="body2" >
                            &nbsp;{(invoice.invoiceGRate).toLocaleString('en-US', {
                              style: 'currency',
                              currency: 'USD',
                            })}
                          </Typography>
                        </TableItem>
                        }
                      </Box>








                      <Box 
                        sx={{
                          display: 'flex',
                          justifyContent: 'right',
                          width: 482,
                          maxWidth: { xs: 708, md: 708 }, 
                        }}
                      >
                        <Typography sx={{ textAlign: 'right'}} variant="body2" fontWeight="800">
                          Invoice Grand Total (All Auth Types):
                        </Typography>
                      </Box>
                      <Box 
                        sx={{
                          display: 'flex', 
                          justifyContent: 'right',
                          width: 80,
                          maxWidth: { xs: 80, md: 80 },
                        }}
                      >
                        <Typography sx={{ textAlign: 'right'}} variant="body2" fontWeight="800">
                          {(invoice.cboInvAmt).toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                          })}
                        </Typography>
                      </Box>
                    </Box>  
                  </Grid>
                </Grid>

	            <Typography sx={{ textAlign: 'left' }} variant="h6" ml={20} mt={2} >
	              	CBP Approval By:______________________________________ Date:___________________
	            </Typography>

              </Box>





            </Box>
            </div>
	)

}
export default ProviderInvoice;	